module.exports = __webpack_public_path__ + "inputs/img/banner2.ef6ee3b5.png";